import {
  DOMESTIC_LOCALE,
  getLanguageMeta,
  SUPPORTED_LANGUAGE_CODES,
} from "./languages";
import { LOCALE_STORAGE_KEY } from "./localeConstants";
import {
  DEFAULT_LANGUAGE,
  detectPreferredLanguageSync,
  resolvePreferredLanguage,
} from "./geoLanguage";

export { LOCALE_STORAGE_KEY } from "./localeConstants";
export { DEFAULT_LANGUAGE, resolvePreferredLanguage } from "./geoLanguage";

export function isSupportedLanguage(code) {
  return SUPPORTED_LANGUAGE_CODES.includes(code);
}

export function stripLocalePrefix(pathname) {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length > 0 && isSupportedLanguage(segments[0])) {
    const rest = segments.slice(1).join("/");
    return rest ? `/${rest}` : "/";
  }
  return pathname || "/";
}

export function getLangFromPathname(pathname) {
  const segment = pathname.split("/").filter(Boolean)[0];
  return isSupportedLanguage(segment) ? segment : null;
}

export function localizePath(path, lang) {
  const code = isSupportedLanguage(lang) ? lang : DEFAULT_LANGUAGE;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const bare = stripLocalePrefix(normalized);
  if (bare === "/") return `/${code}`;
  return `/${code}${bare}`;
}

/** @deprecated 请优先使用 resolvePreferredLanguage（含 IP 国家识别） */
export function detectPreferredLanguage() {
  return detectPreferredLanguageSync();
}

export function getCurrencyForLanguage(lang) {
  return getLanguageMeta(lang).currency;
}

// keep DOMESTIC_LOCALE re-export path stable for existing imports
export { DOMESTIC_LOCALE };
